export function renderLink({ value }) {
  return (
    <a href={value} target="_blank">
      {value}
    </a>
  );
}
export function toLocalDateTime({ value }) {
  return new Date(value).toLocaleString() || "Invalid Date";
}
export const formatIsoDate = (params) => {
  return params.value ? new Date(params.value).toDateString() : "N/A";
};

// export const formatUSDate = (params) => {
//   return params.value
//     ? new Intl.DateTimeFormat("en-US").format(new Date(params.value))
//     : "N/A";
// };
export const formatUSDate = (params) => {
  const date = params.value ? new Date(params.value) : null;

  if (!date || isNaN(date.getTime())) {
    return "N/A";
  }

  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const day = date.getDate().toString().padStart(2, "0");
  const year = date.getFullYear();

  return `${month}/${day}/${year}`;
};
export const formatDate = (params) => {
  let localeDate = new Date(params.value).toLocaleDateString();
  let splitted = localeDate.split("/");
  if (parseInt(splitted[0]) < 10) {
    splitted[0] = "0" + splitted[0];
  }
  if (parseInt(splitted[1]) < 10) {
    splitted[1] = "0" + splitted[1];
  }
  localeDate = splitted.join("/");
  return params.value ? localeDate : "N/A";
};

export const formatCurrency = (params) => {
  return params.value
    ? `$${new Intl.NumberFormat("en-US").format(params.value)}`
    : "N/A";
};

export const formatParentTaskId = (params) => {
  return params.value || "N/A";
};

export const formatCustomDate = (date) => {
  return date ? `${date}`.slice(0, 10) : "N/A";
};

export const formatHour = (params) => {
  return `${params.value ? params.value : 0} Hrs`;
};

export function capitalize(params) {
  if (!params.value) {
    return params.value;
  }
  let firstChar = params?.value?.slice(0, 1).toUpperCase();
  return firstChar + params?.value?.slice(1);
}
export function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}
export const TicketFormatter = (params) => {
  return params.value === "I" ? "Internal" : "External";
};
export const TicketEscalation = (params) => {
  return params.value === true ? "Escalated" : "";
};
export const convertDateFormat = (params) => {
  const dateParts = params.split("-");
  const year = dateParts[0];
  const month = dateParts[1];
  const day = dateParts[2];

  return params ? `${month}/${day}/${year}` : "";
};
export const formatPhoneNumber = (params) => {
  if (!params.value) {
    return ""; // or handle the case when params.value is undefined or null
  }

  const digits = params.value.replace(/\D/g, ""); // Remove non-digit characters
  const firstPart = digits.slice(0, 3); // Extract the first part of the number
  const secondPart = digits.slice(3, 6); // Extract the second part of the number
  const thirdPart = digits.slice(6, 10); // Extract the third part of the number

  return `${firstPart}-${secondPart}-${thirdPart}`; // Format the number with hyphens
};

export function formattedDate(params) {
  const date = new Date(Date.parse(params.value));
  const months = [
    "JAN",
    "FEB",
    "MAR",
    "APR",
    "MAY",
    "JUN",
    "JUL",
    "AUG",
    "SEP",
    "OCT",
    "NOV",
    "DEC",
  ];

  // Get the day, month, and year components
  const day = date.getUTCDate().toString().padStart(2, "0");
  const month = months[date.getUTCMonth()];
  const year = date.getUTCFullYear();
  const hours = date.getUTCHours().toString().padStart(2, "0");
  const minutes = date.getUTCMinutes().toString().padStart(2, "0");

  // Construct the formatted date string
  const formattedDate = `${day}-${month}-${year} ${hours}:${minutes}`;

  return formattedDate;
}

